import { AdminLayout } from "@/views/layouts/AppLayout";
import { InstallPromotionCommissionPage } from "@/views/pages/expenseManagement/installPromotion/InstallPromotionCommissionPage";
import { InstallPromotionCommissionDetailPage } from "@/views/pages/expenseManagement/installPromotion/InstallPromotionCommissionDetailPage";
import { InstallPromotionCommissionSettlePage } from "@/views/pages/expenseManagement/installPromotion/InstallPromotionCommissionSettlePage";
import { ServiceCostBillPage } from "@/views/pages/expenseManagement/userExpense/ServiceCostBillPage";
import { ServiceCostBillDetailPage } from "@/views/pages/expenseManagement/userExpense/ServiceCostBillDetailPage";
import { UserAccountPage } from "@/views/pages/expenseManagement/userExpense/userAccount/UserAccountPage";
import { UserAccountDetailPage } from "@/views/pages/expenseManagement/userExpense/userAccount/UserAccountDetailPage";
import { UserAccountAdvanceFormPage } from "@/views/pages/expenseManagement/userExpense/userAccount/UserAccountAdvanceFormPage";
import { UserAccountAdvanceDetailPage } from "@/views/pages/expenseManagement/userExpense/userAccount/UserAccountAdvanceDetailPage";
import { WillPayPage } from "@/views/pages/expenseManagement/userExpense/willPay/WillPayPage";
import type { AdminRouteObject } from "../index";

/** 费用管理路由，沿用 Vue 安装推广佣金页面权限。 */
export const expenseManagementRoutes: AdminRouteObject = {
    path: "/expenseManagement",
    element: <AdminLayout />,
    handle: { title: "费用管理" },
    children: [
        {
            path: "installPromotion",
            element: <InstallPromotionCommissionPage />,
            handle: { title: "安装推广佣金", permissions: ["ROLE_DEVICE_BONUS_R"] }
        },
        {
            path: "installPromotion/detail/:id",
            element: <InstallPromotionCommissionDetailPage />,
            handle: { title: "安装推广佣金详情", permissions: ["ROLE_DEVICE_BONUS_R"] }
        },
        {
            path: "installPromotion/settle/:id",
            element: <InstallPromotionCommissionSettlePage />,
            handle: { title: "安装推广佣金结算", permissions: ["ROLE_DEVICE_BONUS_W"] }
        },
        {
            path: "serviceCostBill",
            element: <ServiceCostBillPage />,
            handle: { title: "服务费账单", permissions: ["ROLE_ACCOUNT_R", "ROLE_ACCOUNT_VERIFY", "ROLE_PROJECT_R"] }
        },
        {
            path: "serviceCostBill/detail/:id",
            element: <ServiceCostBillDetailPage />,
            handle: {
                title: "服务费账单详情",
                permissions: ["ROLE_ACCOUNT_R", "ROLE_ACCOUNT_VERIFY", "ROLE_PROJECT_R"]
            }
        },
        {
            path: "userAccount",
            element: <UserAccountPage />,
            handle: { title: "用户账户", permissions: ["ROLE_ACCOUNT_R"] }
        },
        {
            path: "userAccount/detail/:id",
            element: <UserAccountDetailPage />,
            handle: { title: "用户账户详情", permissions: ["ROLE_ACCOUNT_R"] }
        },
        {
            path: "userAccount/willPay/add",
            element: <UserAccountAdvanceFormPage />,
            handle: { title: "新增预付款", permissions: ["ROLE_ACCOUNT_W"] }
        },
        {
            path: "userAccount/willPay/add/:customerId",
            element: <UserAccountAdvanceFormPage />,
            handle: { title: "新增预付款", permissions: ["ROLE_ACCOUNT_W"] }
        },
        {
            path: "userAccount/willPay/detail/:id",
            element: <UserAccountAdvanceDetailPage />,
            handle: { title: "预付款记录", permissions: ["ROLE_ACCOUNT_R"] }
        },
        {
            path: "willPay",
            element: <WillPayPage />,
            handle: { title: "待付款", permissions: ["ROLE_ACCOUNT_R", "ROLE_ACCOUNT_MANAGE"] }
        }
    ]
};

export default expenseManagementRoutes;
